import { Component, OnInit, Input } from '@angular/core';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { RoutingService } from 'src/app/services/routing-service/routing.service';
import { SchoolEvent } from '../../../calendar/models/school-event';
import { OnlineMeetingsService } from '../../../online-meetings/services/online-meetings.service';
import { AlertPopupService } from 'alert-popup';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { OnlineMeeting } from '../../../online-meetings/models/online-meeting';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-mobile-time-table',
  templateUrl: './mobile-time-table.component.html',
  styleUrls: ['./mobile-time-table.component.scss']
})
export class MobileTimeTableComponent extends ComponentBase implements OnInit {

  constructor(private onlineMeetingService: OnlineMeetingsService
    , private alertService: AlertPopupService
    , private routingService: RoutingService
    , private settingsService: SettingsService
    , private datePipe: DatePipe) { 
    super();
  }

  @Input() timeTable: Array<SchoolEvent>;
  @Input() exams: Array<SchoolEvent>;
  todaysOnlineMeetings: Array<OnlineMeeting>;
  isOnlineClassEnabled: boolean;
  onlineClassStartTimeBufferMins: number;
  onlineClassEndTimeBufferMins: number;

  ngOnInit() {
    if (this.timeTable && this.timeTable.length){
      let sub = this.settingsService.getSettings().subscribe(res => {
        this.isOnlineClassEnabled = res.is_online_class_enabled;
        this.onlineClassStartTimeBufferMins = res.online_class_start_time_buffer_mins;
        this.onlineClassEndTimeBufferMins = res.online_class_end_time_buffer_mins;
      });
      this.addSubscription(sub);
    }

    let sub1 = this.onlineMeetingService.getUpcomingMeetings()
      .subscribe(res => {
        this.todaysOnlineMeetings = res['upcoming_meetings'];
        if (this.todaysOnlineMeetings.length) {
          this.todaysOnlineMeetings = this.todaysOnlineMeetings.filter(o => (new Date(o.start_time).setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0)) || (o.is_recurring && new Date(o.start_time).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0))).sort((a, b) => (this.getTimeFromDate(a.start_time) > this.getTimeFromDate(b.start_time) ? 1 : -1));
          this.todaysOnlineMeetings.forEach(meeting => {
            if (this.CanJoinScheduledMeeting(meeting)) {
              meeting.can_join = true;
            }
            else {
              meeting.can_join = false;
            }
          });
        }
      });
    this.addSubscription(sub1);
  }

  CanJoinScheduledMeeting(meeting: OnlineMeeting) {
    if (!meeting.is_recurring && new Date(meeting.start_time).getTime() <= new Date().getTime()) {
      return true;
    }
    else if (meeting.is_recurring && new Date(meeting.start_time).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)) {
      return true;
    }
    else {
      return false;
    }
  }

  JoinScheduledMeeting(joinUrl: string) {
    window.open(joinUrl, '_system');
  }

  getTimeFromDate(date: Date): string {
    let new_date = new Date(date);
    return this.datePipe.transform(new_date, 'HH:mm');
  }

  CanJoinMeeting(subject: SchoolEvent) {
    var start = new Date(subject.start_date).getTime() - this.onlineClassStartTimeBufferMins * 60000;
    var end =  new Date(subject.end_date).getTime() + this.onlineClassEndTimeBufferMins * 60000;
    var dt = new Date();
    if (dt.getTime() >= start && dt.getTime() <= end) {
      return true;
    }
    return false;
  }

  OnJoinMeeting(eventOccurrenceId: number) {
    let sub = this.onlineMeetingService.getJoinUrlForEvent(eventOccurrenceId).subscribe(res => {
      window.open(res['join_url'], "_system");
    }, err => {
      if (err.error.code == "MEETING_NOT_FOUND"){
        let route = new PrifactRoute();
        route.primary_command = ['online-meeting-lobby'];
        route.query_params = { 
          "eventId": eventOccurrenceId.toString()
        };
        route.append_current_url_to_history = true;
        this.routingService.navigate(route);
      }
      else{
        this.alertService.newAlert(err.error.message);
      }
    });
    this.addSubscription(sub);
  }
}
